'use client';

import { DEFAULT_VARIANTS_DEFAULT_ROW } from './constants';
import { PanelBase, PanelIndicator } from './PanelBase';
import type { AnimatedIconProps } from './types';

/**
 * Animated icon showing the visible or selected states of the viewer
 */
export const AnimatedIconPanelAssetDefaultRow = ({
  $isSelected,
  ...props
}: AnimatedIconProps) => (
  <PanelBase {...props}>
    <PanelIndicator
      $isSelected={$isSelected}
      variants={DEFAULT_VARIANTS_DEFAULT_ROW}
      width="10"
      x="7"
    />
  </PanelBase>
);
